module.exports = __webpack_public_path__ + "media/phone-calling.f325aa38.mp3";